import withRouter from "component/utilies/withRouter";
import img from "images/img.jpg";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { createTheme, responsiveFontSizes, Typography } from "@mui/material";
import "./HeaderBackoffice.css";

function HeaderBackoffice(props) {
  let theme = createTheme();
  theme = responsiveFontSizes(theme);
  const Style = {
    h1: {
      color: "white",
      backgroundColor: "#009bdb",
      padding: "10px",
      marginTop: "10px",
    },
  };

  const backoffice = props.backoffice;
  const title = null;
  const welcome = null;
  const button = null;
  return (
    <Container fixed>
      <Grid container sx={{ width: "100%" }} style={{ marginTop: "1%" }}>
        <Grid size="grow">
          <div>
            <img
              src="https://www.aysa.com.ar/assets/Menu/img/logo.png"
              alt="aysa logo"
            />
          </div>
        </Grid>
        <Grid size="grow">
          <div
            style={{
              marginTop: theme.spacing(1),
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ alignSelf: "flex-end", marginBottom: "1%" }}>
              <Typography
                variant="p"
                style={{
                  marginBottom: "1%",
                  fontSize: "16pt",
                  fontFamily: "Roboto ",
                }}
              >
                {props.welcome || welcome}
              </Typography>
            </div>
            <div style={{ alignSelf: "flex-end" }}>
              {" "}
              {props.button || button}
            </div>
          </div>
        </Grid>
      </Grid>
      <div style={Style.h1}>
        <Grid container spacing={6} sx={{ width: "100%" }}>
          <Grid size="grow">
            <Typography variant="h1" className="title__header-backoffice">
              BackOffice {backoffice}
            </Typography>
          </Grid>
          <Grid size="grow">
            <Typography
              variant="h1"
              align="right"
              style={{ marginRight: "10%" }}
              className="title__header-backoffice"
            >
              {props.title || title}
            </Typography>
          </Grid>
        </Grid>
      </div>
      <div>
        <img style={{ width: "100%" }} src={img} alt="foto" />
      </div>
    </Container>
  );
}
export default withRouter(HeaderBackoffice);
